var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Slider } from '../../../components/SlideDown';
import { Grid } from '../../../components/Grid';
export class ArchiveEvents extends Component {
    constructor() {
        super('ArchiveEvents', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.page-template-events .menu-filters .slide-down-content a').on('click', (event, filter) => {
                event.preventDefault();
                $('.page-template-events .menu-filters .slide-down-content a').removeClass('text-primary');
                filter.addClass('text-primary');
                Slider.close($('.page-template-events .menu-filters .slide-down'));
                $('.filter-item').addClass('d-none');
                let target = (filter.data('value') != 'all') ? '[data-category="' + filter.data('value') + '"]' : '';
                $('.filter-item' + target).removeClass('d-none');
                Grid.updateGrid($('.grid'));
            });
            this.success();
        });
    }
}
